import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'df-funnel-manage-content-empty-state',
  templateUrl: './funnel-manage-content-empty-state.component.html',
  styleUrls: ['./funnel-manage-content-empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FunnelManageContentEmptyStateComponent {}
